
const Modal = require('app/ui/Modal');
const ListTable = require('app/ui/list/Table');

class NetSaleRangeRankView {

    defaultOptions(){
        return {
            '$container': null,
            'data': null,
            'limit': 15,
            'supplier': null,
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onClickShowAll = this.onClickShowAll.bind(this);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.data = this.settings.data;
        this.supplier = this.settings.supplier;

        this.initialize();
    }

    initialize() {
        var self = this;

        this.$container
        .html('')
        .append(this.buildHeader())
        .append(this.buildList())

    }

    buildHeader(){
        let $header = $("<h3/>")
        .addClass('box-title')
        .append(window.translate('app.supplier.show.tabs.stat.netSaleRangeRank.title'))

        return $header;
    }

    buildList(){
        this.$list = $('<div/>');
        let limit = this.settings.limit;
        let $footerContent = null;
        if(this.data.length > limit){
            $footerContent = $("<tr/>")
            .append(
                $('<th/>')
                .attr('colspan',3)
                .append(
                    $('<div/>')
                    .addClass('d-flex justify-content-center')
                    .append(
                        $('<button/>')
                        .addClass('btn btn-primary')
                        .append(window.translate('seeAll'))
                        .append(
                            $('<i/>')
                            .addClass('far fa-arrow-right ms-1')
                        )
                        .on('click',this.onClickShowAll)
                    )
                )
            )
        }

        this.drawTable(this.$list,limit,$footerContent);

        return this.$list;
    }

    drawTable($container,limit,$footerContent){
        let total = 0;
        for(var i in this.data){
            total += this.data[i].netSale;
        }
        let table = new ListTable({
            '$container': $container,
            'tableClass': 'table table-striped',
            'id': 'ordercount-list',
            'length': limit,
            'data': this.data,
            'footerContent': $footerContent,
            'columns': [
                {
                    'name': 'name',
                    'label': window.translate('app.supplier.show.tabs.stat.range.name.label'),
                    'class': 'range-name',
                    'render': function(item,index){
                        return item.range.name;
                    },
                },
                {
                    'name': 'total',
                    'label': window.translate('total'),
                    'class': 'total',
                    'render': function(item,index){
                        return window.formatFloat(item.netSale) + ' &euro;';
                    },
                },
                {
                    'name': 'percent',
                    'label': '%',
                    'class': 'percent',
                    'render': function(item,index){
                        let percent = (item.netSale / total) * 100;
                        return window.formatFloat(percent) + ' %';
                    },
                }
            ]
        });
    }

    onClickShowAll(event){
        event.preventDefault();
        event.stopPropagation();

        let $content = $('<div/>');

        this.drawTable($content,0,null);

        let modal = new Modal({
            'title': window.translate('app.supplier.show.tabs.stat.netSaleRangeRank.title'),
            'modalSize': 'full',
            'content': $content
        });
        modal.show();
    }
}

module.exports = NetSaleRangeRankView;

